export enum LinkType {
  CDL_LIFE = 'CDL_LIFE',
  CAREER_NOW_BRANDS = 'CAREER_NOW_BRANDS',
  COMPANY_WEBSITE = 'COMPANY_WEBSITE',
  CRAIGSLIST = 'CRAIGSLIST',
  CUSTOM = 'CUSTOM',
  DRIVERS_FIRST = 'DRIVERS_FIRST',
  ACQUIRE_ROI = 'ACQUIRE_ROI',
  FACEBOOK = 'FACEBOOK',
  FUSION_NOW = 'FUSION_NOW',
  INDEED = 'INDEED',
  INSTAGRAM = 'INSTAGRAM',
  TELEGRAM = 'TELEGRAM',
  KJ_MEDIA = 'KJ_MEDIA',
  LINKEDIN = 'LINKEDIN',
  M3TRAFFIC = 'M3TRAFFIC',
  RAMSEY_MEDIAWORKS = 'RAMSEY_MEDIAWORKS',
  RANDALL_REILLY = 'RANDALL_REILLY',
  RECRUITER = 'RECRUITER',
  REFERRAL = 'REFERRAL',
  TRANSPORTATION_MARKETING_GROUP = 'TRANSPORTATION_MARKETING_GROUP',
  TRUCK_DRIVERS_USA = 'TRUCK_DRIVERS_USA',
  TRUCKERS_REPORT = 'TRUCKERS_REPORT',
  TRUCKER_MEDIA_GROUP = 'TRUCKER_MEDIA_GROUP',
  DATA_MIGRATION = 'DATA_MIGRATION',
  SEATED_SOCIAL = 'SEATED_SOCIAL',
  RCI = 'RCI',
  CDL_JOBS = 'CDL_JOBS',
  THE_JOBS_DRIVER = 'THE_JOBS_DRIVER',
  DIGITAL_MARKETING_GEN = 'DIGITAL_MARKETING_GEN',
  BE_SOCIAL = 'BE_SOCIAL',
  VERITONE = 'VERITONE',
  HIREMASTER = 'HIREMASTER',
  TRUCKING_CLICKS = 'TRUCKING_CLICKS',
  SWISH = 'SWISH',
  HAYES_RECRUITING = 'HAYES_RECRUITING',
  TRANSFORCE = 'TRANSFORCE',
  PARADIGM = 'PARADIGM',
  JOB_CAST = 'JOB_CAST',
}

export enum LinkTypeDisplay {
  CDL_LIFE = 'CDL Life',
  CAREER_NOW_BRANDS = 'Career Now Brands',
  COMPANY_WEBSITE = 'Company Website',
  CRAIGSLIST = 'Craigslist',
  CUSTOM = 'Custom',
  DRIVERS_FIRST = "Driver's First",
  ACQUIRE_ROI = 'AcquireROI',
  FACEBOOK = 'Facebook',
  FUSION_NOW = 'Fusion Now',
  INDEED = 'Indeed',
  INSTAGRAM = 'Instagram',
  TELEGRAM = 'Telegram',
  KJ_MEDIA = 'KJ Media',
  LINKEDIN = 'LinkedIn',
  M3TRAFFIC = 'M3Traffic',
  RAMSEY_MEDIAWORKS = 'Ramsey MediaWorks',
  RANDALL_REILLY = 'Randall Reilly',
  REFERRAL = 'Referral',
  RECRUITER = 'Recruiter',
  TRANSPORTATION_MARKETING_GROUP = 'Transportation Marketing Group',
  TRUCK_DRIVERS_USA = 'Truck Drivers USA',
  TRUCKERS_REPORT = "Trucker's Report",
  TRUCKER_MEDIA_GROUP = 'Trucker Media Group',
  DATA_MIGRATION = 'Data Migration',
  SEATED_SOCIAL = 'Seated Social',
  RCI = 'RCI',
  CDL_JOBS = 'CDLjobs.com',
  THE_JOBS_DRIVER = 'The Jobs Driver',
  DIGITAL_MARKETING_GEN = 'Digital Marketing Gen',
  BE_SOCIAL = 'Be Social',
  VERITONE = 'Veritone',
  HIREMASTER = 'HireMaster',
  TRUCKING_CLICKS = 'Trucking Clicks',
  SWISH = 'Swish',
  HAYES_RECRUITING = 'Hayes Recruiting',
  TRANSFORCE = 'Transforce',
  PARADIGM = 'Paradigm',
  JOB_CAST = 'JobCast',
}
